import { emailValidation } from "../../../../utils/GeneralUtils";

const validate = (values: any, props: any) => {
  const errors: {
    businessName: any;
    productName: any;
    businessZipCode: any;
    businessPhoneNumber: any;
    businessEmail: any;
    contactZipCode: any;
    locationName: any;
    name: any;
    url: any;
    emailContact: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    title: string | undefined;
    email: string | undefined;
    emailType: string | undefined;
    roles: string | undefined;
    newPassword: string | undefined;
    confirmNewPassword: string | undefined;
    phoneNumber: string | undefined;
    phoneType: string | undefined;
    time: string | undefined;
    dob: string | undefined;
    recipient: any;
    subject: string | undefined;
    message: string | undefined;
    expectedClose: string | undefined;
    account: string | undefined;
    contactFirstName: string | undefined;
    action: string | undefined;
    product: string | undefined;
    contact: string | undefined;
    interaction: string | undefined;
    nextActionDate: string | undefined;
    assignActionTo:string| undefined;
  } = {
    businessName: undefined,
    account: undefined,
    businessEmail: undefined,
    businessPhoneNumber: undefined,
    title: undefined,
    locationName: undefined,
    emailType: undefined,
    name: undefined,
    url: undefined,
    emailContact: undefined,
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    roles: undefined,
    productName: undefined,
    newPassword: undefined,
    confirmNewPassword: undefined,
    phoneNumber: undefined,
    phoneType: undefined,
    time: undefined,
    dob: undefined,
    recipient: undefined,
    subject: undefined,
    message: undefined,
    businessZipCode: undefined,
    contactZipCode: undefined,
    expectedClose: undefined,
    contactFirstName: undefined,
    action: undefined,
    product: undefined,
    contact: undefined,
    interaction: undefined,
    nextActionDate: undefined,
    assignActionTo:undefined,
  };

  if (!values.businessName) {
    errors.businessName = "Required";
  }
  if (!values.contactFirstName) {
    errors.contactFirstName = "Required";
  }
  if (values.email && !emailValidation().test(values.email)) {
    errors.email = "*Please enter your email in format: yourname@example.com ";
  } 
  if (values.email) {
    if (!values.emailType) {
      errors.emailType = "Required";
    }
  }
  if (values.emailType) {
    if (!values.email) {
      errors.email = "Required";
    }
  }

  if (values.phoneNumber) {
    if (values.phoneNumber.length < 11) {
      errors.phoneNumber = "Enter 10 digits";
    }
    if (!values.phoneType) {
      errors.phoneType = "Required";
    }
  }
  if (values.phoneType) {
    if (!values.phoneNumber) {
      errors.phoneNumber = "Required";
    }
  }

  if (
    values.businessZipCode === "0" ||
    values.businessZipCode === "00" ||
    values.businessZipCode === "000" ||
    values.businessZipCode === "0000" ||
    values.businessZipCode === "00000"
  ) {
    errors.businessZipCode = "Invalid zip";
  }
  if (
    values?.businessZipCode?.length < 5 &&
    values?.businessZipCode?.length !== 0
  ) {
    errors.businessZipCode = "5 digits required";
  }
  if (
    values.contactZipCode === "0" ||
    values.contactZipCode === "00" ||
    values.contactZipCode === "000" ||
    values.contactZipCode === "0000" ||
    values.contactZipCode === "00000"
  ) {
    errors.contactZipCode = "Invalid zip";
  }
  if (
    values?.contactZipCode?.length < 5 &&
    values?.contactZipCode?.length !== 0
  ) {
    console.log("")
    errors.contactZipCode = "5 digits required";
  }
  if (!values.time) {
    errors.time = "Please select a slot";
  }
  if (values.date) {
    if (values?.time.length < 3) {
      errors.time = "Please select a slot";
    }
  }
  if (values.expectedClose) {
    const date = new Date(values.expectedClose);
    const currentDate = new Date();
    const twelveMonthsFromNow = new Date();
    twelveMonthsFromNow.setFullYear(currentDate.getFullYear() + 1);
    if (date.getTime() > twelveMonthsFromNow.getTime()) {
      errors.expectedClose = "Date is over 12 months";
    }
  }
  if (!values.nextActionDate) {
    errors.nextActionDate = "Required";
  }

  if (values.nextActionDate) {
    const date = new Date(values.nextActionDate);
    const currentDate = new Date();
    const twelveMonthsFromNow = new Date();
    twelveMonthsFromNow.setFullYear(currentDate.getFullYear() + 1);
    if (date.getTime() > twelveMonthsFromNow.getTime()) {
      errors.nextActionDate = "Date is over 12 months";
    }
  }

  if (values.account && props.fromDetailsPage) {
    if (!values.productName) {
      errors.account = "Select Product Name";
    }
  }
  if (!values.action) {
    errors.action = "Required";
  }
  if (!values.product) {
    errors.product = "Required";
  }
  if (!values.contact) {
    errors.contact = "Required";
  }
  if (!values.interaction) {
    errors.interaction = "Required";
  }
  if (!values.assignActionTo) {
    errors.assignActionTo = "Required";
  }
  return errors;
};

export default validate;
